//auth routes
export const accountLogin = "api/LoginToAccount";
export const userLogout = "api/userLogout/";
// end auth routes

//roles
export const addNewRole = "api/newRole";
export const LoadRoles = "api/roles/";
export const updateRole = "api/roleUpdate";
export const deleteRole = "api/roleDelete/";
//end roles

//end modules
export const newModules = "api/newModule";
export const loadModules = "api/modules";
export const deleteModule = "api/moduleDelete/";
//modules

//permissions
export const newPermissions = "api/newPermission";
export const loadPermissions = "api/permissions";
export const deletePermission = "api/permissionDelete/";
//end permissions

//users
export const newUsers = "api/newUser";
export const loadUsers = "api/users";
export const updateUsers = "api/userUpdate";
export const deleteUser = "api/userDelete/";
export const Userprofile = "api/profileDetails";
export const updateProfile = "api/profileUpdate";
export const updateProfileImg = "api/updateUserImage";
//end users

//user roles
export const userRoles = "api/userRoles/";
export const modulePermissions = "api/modulePermissions";
export const asignuserRoleModules = "api/asignRoleModules";
export const asignModulePermissions = "api/assignModulesPermissions";
//end userroles

//products
export const newProduct = "api/newProduct";
export const loadProducts = "api/products";
export const loadProductstat = "api/statproductsales";
export const getProducts = "api/singleproducts";
export const getDeadProducts = "api/deadproducts";
export const updateProduct = "api/productUpdate";
export const loadNumber = "api/prod_no";
//end products

//suppliers
export const newSupplier = "api/newSupplier";
export const loadSuppliers = "api/suppliers";
export const supplierUpdate = "api/updateSupplier";
//end suppliers

//stock
export const newStock = "api/newstock";
export const loadStocks = "api/stocks";
export const loadStock = "api/stock";
export const loadReorderStock = "api/reorderstock";
//end stock

export const newDeadstock = "api/newDeadstock";
export const loadDeadStocks = "api/deadstocks";
export const loadDeadStock = "api/deadstock";
//end stock

//transporters
export const newTransporters = "api/newTransporter";
export const loadTransporters = "api/transporters";
export const updateTransporter = "api/transporterUpdate";
export const loadtransporterTrucks = "api/transportertrucks";
//end transporters

//trucks
export const newTruck = "api/newTruck";
export const loadTrucks = "api/trucks";
export const loadTruck = "api/truck";
export const updateTruck = "api/truckUpdate";
//end trucks

//accounttypes
export const newAccount = "api/newAccount";
export const loadAccounttype = "api/accounttypes";
//end accounttypes

//petty cash
export const newPettycash = "api/newCash";
export const loadPettycashes = "api/pettycashes";
export const loadPetty = "api/pettycash";
//end petty cash

//purchase orders
export const newPurchaseorder = "api/newPurchaseorder";
export const loadPurchaseorders = "api/purchaseorders";
export const viewPurchaseorders = "api/purchaseorder";
export const checkPurchaseorders = "api/purchase_order_item";
//end purchase

//goods receiving note
export const newGoodsreceivingnote = "api/newGrn";
export const loadGoodsreceiving = "api/goodsreceiving";
export const loadGoodsnote = "api/goodreceiving";
export const editGoodsnote = "api/good_receiving_items";
export const updateNote = "api/noteUpdate";
//end goods receiing note

//purchases
export const getNote = "api/purchase_receiving_item";
export const newpurchase = "api/newPurchase";
export const loadPurchases = "api/purchases";
export const viewPurchase = "api/purchase";
//end purchases

//sales
export const newSales = "api/newSale";
export const loadSales = "api/sales";
export const viewSale = "api/sale";
export const editSale = "api/sale_item";
//end sales

//sales
export const newDeadSales = "api/newDeadSale";
export const loadDeadSales = "api/deadsales";
export const viewDeadSale = "api/deadsale";
//end sales

//expenses
export const newExpense = "api/newExpense";
export const loadExpenses = "api/expenses";
//end expenses

//reports
export const loadTruckSales = "api/trucksales";
export const loadFullSales = "api/fullsales";
export const loadTruckdeadSales = "api/truckdeadsales";
export const loadFulldeadSales = "api/fulldeadsales";
export const loadProductSales = "api/productsales";
export const loadFullProductSales = "api/fullproductsales";
export const loadTruckExpenses = "api/truckexpenses";
export const loadFullExpenses = "api/fullexpenses";
export const loadProductPurchases = "api/productpurchases";
export const loadFullPurchases = "api/fullpurchases";
export const loadTruckLabours = "api/trucklabours";
export const loadFullLabours = "api/fulllabours";
export const loadFullLabour = "api/fullnumberlesslabours";
export const loadTruckExpense = "api/truckexpense";
export const loadFullExpense = "api/fullexpense";
export const loadDiffTyre = "api/difftyres";
export const loadEmployeeAttendances = "api/employeeattendances";
export const loadContainerInterchanges = "api/containerinterchanges";
export const loadTruckInterchanges = "api/truckinterchanges";
export const loadSuppliergoods = "api/suppliergoods";
export const loadmileages = "api/fullmileages";
export const loadTripsummary = "api/truckincome";
//end reports

//labours
export const newLabour = "api/newLabour";
export const laodLabours = "api/labours";
export const editLabour = "api/labour_items";
export const updateLabour = "api/updateLabour";
//end labours

//labours
export const newNumberlessLabour = "api/newnumberlessLabour";
export const loadNumberlessLabours = "api/numberlesslabours";

//end labours

//oilgrns
export const newOil = "api/newOil";
export const loadOils = "api/oils";
export const loadGrnsnote = "api/oil";
//end oilgrns

//interchanges
export const newInterchange = "api/newInterchange";
export const loadInterchanges = "api/interchanges";
//end interchanges

//employees
export const addNewEmployee = "api/newEmployee";
export const loadEmployees = "api/employees";
// export const loadDrivers = "api/drivers";
export const updateEmployee = "api/employeeUpdate";
//end employees

//occupations
export const newOccupation = "api/newOccupation";
export const loadOccupation = "api/occupations";
export const updateOccupation = "api/occupationUpdate";
//end occupations

//employee deduction
export const newDeduction = "api/newDeduction";
export const loadDeductions = "api/employeedeductions/";
export const deductionUpdate = "api/deductionUpdate";
export const loadPayroll = "api/payroll";
//end employe deduction

//attendances
export const checksIn = "api/checkIn";
export const loadAttendances = "api/attendances";
export const loadAttendance = "api/attendance";
export const checksOut = "api/checkOut";
//end attendances

//invoices
export const newInvoice = "api/newInvoice";
export const loadInvoices = "api/invoices";
//end invoices

//mileages
export const newMileage = "api/newMileage";
export const loadMileages = "api/mileages";
export const loadMileage = "api/mileage";
//end mileages

//cfs
export const newCfs = "api/newCfs";
export const loadCfs = "api/cfs";
export const updateCfs = "api/cfsUpdate";
//end cfs

//destination
export const newDestination = "api/newDestination";
export const loadDestinations = "api/destinations";
export const destinationUpdate = "api/updateDestination";
//end destination

//job card
export const newJobcard = "api/newJobcard";
export const loadJobcards = "api/jobcards";
export const viewjobcardsale = "api/jobcardsale";
export const updateJobcard = "api/updateJobcard";
//end job card

//truck attendances
export const newCheckin = "api/checkinTruck";
export const loadTruckattendances = "api/truckattendances";
export const updateCheckout = "api/checkoutTruck";
export const loadTruckattendance = "api/truckattendance";
///end truck attendances

//drivers
export const newDriver = "api/newDriver";
export const loadDrivers = "api/drivers";
export const updateDriver = "api/driverUpdate";
//end drivers

//truck documents
export const newDocument = "api/truckImage";
//end truck documents

//trip
export const newTrip = "api/newTrip";
export const loadTrips = "api/trips";
export const updateTrip = "api/tripUpdate";
//end trip

//consignee
export const newConsignees = "api/newConsignee";
export const loadConsignees = "api/consignees";
//end consignee

//stations
export const newStation = "api/newStations";
export const loadStations = "api/stations";
//end stations

//fuel
export const newFuel = "api/newFuel";
export const loadFuels = "api/fuels";
export const viewFuel = "api/fuel";
export const viewFuels = "api/fuel_item";
//end fuel

//commissions
export const newCommissions = "api/newCommission";
export const loadCommissions = "api/commissions";
//end commissions

//parking
export const newParking = "api/newParking";
export const loadParkings = "api/parkings";
export const viewParkings = "api/parking";
//end parking



// WEBPACK FOOTER //
// ./src/routes/routes.js